import { sendParameters } from '../../../common/functions'
import TaskWrapper from './TaskWrapper'

export default function InitialCalculationCheckWidget({ task, isCanceled }) {
  return (
    <TaskWrapper
      task={task}
      label="Проверка калькуляции"
      isCanceled={isCanceled}
      onSave={() => sendParameters(task.paidServiceId, task.id, {}, [])}
      saveButtonLabel="Проверено"
    />
  )
}
